export { default } from "ember-stereo/-private/utils/connection-loader";
